export default __webpack_public_path__ + "static/media/YAS0290.34I-27698_-16622_0.6581635f.jpg";